(function ($) {
  "use strict";
  var API_URL =
    "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2838&deploy=1&compid=1117015&ns-at=AAEJ7tMQFAvkMfW4cJSxfvrvlXo-xKfXC9kWLAqn40JNZzeHAbI&brandfld=custentity_lifespandealer";
  var RADIUS_KM = 100;
  var MIN_RESULTS = 5;
  var MAX_RESULTS = 50;
  var COUNTRY = "au";
  var PIN_XLAB_RACE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="50" viewBox="0 0 38 50" fill="none"><path d="M18.8962 49.4558H18.1243C17.6724 49.2424 17.2895 48.9224 16.913 48.5897C10.2979 42.7404 2.15146 31.7822 0.425523 23.027C-3.61004 2.56673 22.0971 -8.49812 33.6389 7.94539C42.482 20.5542 32.1703 35.9747 23.3397 45.3512C22.3418 46.4119 21.0489 47.7927 19.9632 48.7278C19.6368 49.0102 19.2916 49.2613 18.9025 49.4496L18.8962 49.4558ZM18.482 8.30313C10.5992 8.32823 5.67238 16.9203 9.62636 23.7613C13.5803 30.6023 23.0322 30.5709 27.1431 24.1692C31.5427 17.3157 26.6222 8.27175 18.4883 8.29685L18.482 8.30313Z" fill="black"/><path d="M18.4695 3.32625C30.89 3.28231 38.3962 17.0836 31.6807 27.5459C25.4109 37.3179 10.7561 36.9727 4.95063 26.9183C-1.08702 16.4748 6.43808 3.37018 18.4695 3.32625Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.5453 19.6292H11.6642C11.6195 19.6292 11.5833 19.593 11.5833 19.5483V18.9185C11.5833 18.8738 11.6195 18.8376 11.6642 18.8376H13.5453C13.5901 18.8376 13.6262 18.8738 13.6262 18.9185V19.5483C13.6262 19.593 13.5896 19.6292 13.5453 19.6292ZM16.2744 20.6111V17.0809C16.2744 17.0362 16.2382 17 16.1934 17H15.5637C15.5189 17 15.4828 17.0362 15.4828 17.0809V20.2908C15.4828 20.3506 15.5017 20.4092 15.537 20.4578L16.2253 21.4009C16.2559 21.4427 16.3045 21.4672 16.3557 21.4672H19.5109C19.5557 21.4672 19.5918 21.4311 19.5918 21.3863V20.7565C19.5918 20.7118 19.5557 20.6756 19.5109 20.6756H16.3381C16.3036 20.6756 16.2744 20.6468 16.2744 20.6111ZM9.24941 17.7916H10.2089C10.2537 17.7916 10.2898 17.7554 10.2898 17.7107V17.0809C10.2898 17.0362 10.2537 17 10.2089 17H8.86803C8.81638 17 8.76773 17.0245 8.7376 17.0663L7.6972 18.4911C7.67138 18.5264 7.61843 18.5264 7.5926 18.4911L6.55221 17.0663C6.52164 17.0245 6.473 17 6.42178 17H5.08092C5.03616 17 5 17.0362 5 17.0809V17.7107C5 17.7554 5.03616 17.7916 5.08092 17.7916H6.0404C6.07914 17.7916 6.11573 17.8101 6.13854 17.8415L7.38771 19.5526C7.41095 19.5844 7.38814 19.6296 7.34854 19.6296H6.92799C6.88925 19.6296 6.85266 19.6481 6.82985 19.6796L6.1351 20.6309C6.11228 20.6623 6.0757 20.6808 6.03696 20.6808H5.08092C5.03616 20.6808 5 20.7169 5 20.7617V21.391C5 21.4358 5.03616 21.472 5.08092 21.472L6.42178 21.4681C6.47343 21.4681 6.52164 21.4431 6.55177 21.4018L7.59217 19.977C7.618 19.9417 7.67095 19.9417 7.69677 19.977L8.73717 21.4018C8.7673 21.4435 8.81595 21.4681 8.86717 21.4681L10.208 21.472C10.2528 21.472 10.2889 21.4358 10.2889 21.391V20.7617C10.2889 20.7169 10.2528 20.6808 10.208 20.6808H9.25199C9.21325 20.6808 9.17666 20.6623 9.15385 20.6309L7.90124 18.9155C7.87799 18.8837 7.90081 18.8385 7.94041 18.8385H8.36096C8.3997 18.8385 8.43629 18.8199 8.4591 18.7885L9.15041 17.8415C9.17408 17.8097 9.21067 17.7916 9.24941 17.7916ZM24.3823 17H21.5633C21.5117 17 21.463 17.0245 21.4329 17.0663L20.7446 18.0094C20.7093 18.058 20.6899 18.1162 20.6899 18.1764V21.3863C20.6899 21.4311 20.7261 21.4672 20.7709 21.4672H21.4006C21.4454 21.4672 21.4815 21.4311 21.4815 21.3863V17.8562C21.4815 17.8204 21.5104 17.7916 21.5461 17.7916H24.4004C24.4361 17.7916 24.465 17.8204 24.465 17.8562V18.773C24.465 18.8088 24.4361 18.8376 24.4004 18.8376H22.3553C22.3037 18.8376 22.255 18.8621 22.2249 18.9039L21.7518 19.5517C21.7286 19.5836 21.7514 19.6288 21.791 19.6288H24.4008C24.4366 19.6288 24.4654 19.6576 24.4654 19.6933V21.3854C24.4654 21.4302 24.5016 21.4664 24.5463 21.4664H25.1761C25.2209 21.4664 25.257 21.4302 25.257 21.3854V18.1756C25.257 18.1157 25.2381 18.0572 25.2028 18.0085L24.5145 17.0654C24.4826 17.0245 24.434 17 24.3823 17ZM30.7948 19.5521C30.7715 19.584 30.7943 19.6292 30.8339 19.6292H31.449C31.4938 19.6292 31.53 19.6654 31.53 19.7101V20.2908C31.53 20.3506 31.511 20.4092 31.4757 20.4578L30.7874 21.4009C30.7569 21.4427 30.7082 21.4672 30.657 21.4672H27.0451C27.0003 21.4672 26.9642 21.4311 26.9642 21.3863V17.0809C26.9642 17.0362 27.0003 17 27.0451 17H30.657C30.7087 17 30.7573 17.0245 30.7874 17.0663L31.4757 18.0094C31.511 18.058 31.53 18.1162 31.53 18.1764V18.4532C31.53 18.513 31.511 18.5716 31.4757 18.6202L30.7948 19.5521ZM27.7545 18.773C27.7545 18.8088 27.7833 18.8376 27.8191 18.8376H30.6734C30.7091 18.8376 30.7379 18.8088 30.7379 18.773V17.8562C30.7379 17.8204 30.7091 17.7916 30.6734 17.7916H27.8191C27.7833 17.7916 27.7545 17.8204 27.7545 17.8562V18.773ZM30.7384 19.6938C30.7384 19.658 30.7095 19.6292 30.6738 19.6292H27.8195C27.7838 19.6292 27.7549 19.658 27.7549 19.6938V20.6106C27.7549 20.6463 27.7838 20.6752 27.8195 20.6752H30.6738C30.7095 20.6752 30.7384 20.6463 30.7384 20.6106V19.6938Z" fill="#020202"/><path d="M20.6581 24.3358H19.9216L19.8183 23.7921H18.7322L18.5545 24.3358H17.8976L18.3491 22.948C18.3616 22.911 18.3711 22.8723 18.3793 22.8353C18.3875 22.7982 18.3862 22.7638 18.378 22.7294C18.3698 22.6962 18.3478 22.6661 18.3134 22.6398H20.8466C20.9361 22.6398 21.0037 22.6717 21.0463 22.7363C21.0903 22.8008 21.0971 22.8796 21.0683 22.9687L20.9073 23.4629C20.8841 23.5386 20.8384 23.6062 20.7726 23.6652C20.7063 23.7246 20.6335 23.7629 20.5535 23.7822L20.6581 24.3358ZM20.095 23.5016C20.1351 23.5016 20.1734 23.4852 20.2121 23.4534C20.2509 23.4215 20.2767 23.3845 20.2892 23.3445L20.3774 23.0746C20.3899 23.0346 20.3869 23.0014 20.3692 22.9726C20.3499 22.9437 20.321 22.93 20.281 22.93H19.0116L18.8256 23.5012H20.095V23.5016Z" fill="black"/><path d="M24.2898 24.3358H23.5201L23.3716 23.8731H22.1491L21.6976 24.3358H21.308L22.6433 22.9661C22.6997 22.9054 22.7354 22.8503 22.7522 22.7995C22.7729 22.735 22.7604 22.6812 22.7135 22.6398H23.7418L24.2898 24.3358ZM23.2765 23.5829L23.066 22.9304L22.4298 23.5829H23.2765Z" fill="black"/><path d="M27.5117 24.3358H25.2196C25.13 24.3358 25.0642 24.304 25.0198 24.2394C24.9772 24.1748 24.9703 24.0978 24.9992 24.0069L25.3474 22.9347C25.3586 22.9003 25.3681 22.8658 25.375 22.8301C25.3819 22.7944 25.3806 22.7599 25.3724 22.7268C25.3629 22.6949 25.3405 22.6661 25.3078 22.6403H28.064L27.9689 22.9308H26.1489C26.1102 22.9308 26.0719 22.9446 26.0331 22.9721C25.9961 23.001 25.9711 23.0354 25.9574 23.0754L25.6888 23.9015C25.6763 23.9415 25.6793 23.9747 25.6982 24.0035C25.7172 24.0323 25.7464 24.0461 25.7865 24.0461H27.6064L27.5117 24.3358Z" fill="black"/><path d="M28.3872 24.3358L28.8375 22.9536C28.85 22.9166 28.8595 22.8779 28.8676 22.8396C28.8758 22.8008 28.8758 22.7651 28.8676 22.7307C28.8595 22.6962 28.8358 22.6661 28.8013 22.6398H31.3057L31.2106 22.9304H29.4995L29.3687 23.3337H31.0246L30.9295 23.6243H29.2735L29.1371 24.0457H30.8481L30.753 24.3362H28.3872V24.3358Z" fill="black"/></svg>';
  var PIN_XLAB_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="50" viewBox="0 0 38 50" fill="none"><path d="M18.8962 49.4558H18.1243C17.6724 49.2424 17.2895 48.9224 16.913 48.5897C10.2979 42.7404 2.15146 31.7822 0.425523 23.027C-3.61004 2.56673 22.0971 -8.49812 33.6389 7.94539C42.482 20.5542 32.1703 35.9747 23.3397 45.3512C22.3418 46.4119 21.0489 47.7927 19.9632 48.7278C19.6368 49.0102 19.2916 49.2613 18.9025 49.4496L18.8962 49.4558ZM18.482 8.30313C10.5992 8.32823 5.67238 16.9203 9.62636 23.7613C13.5803 30.6023 23.0322 30.5709 27.1431 24.1692C31.5427 17.3157 26.6222 8.27175 18.4883 8.29685L18.482 8.30313Z" fill="black"/><path d="M18.4695 3.32622C30.89 3.28228 38.3962 17.0835 31.6807 27.5459C25.4109 37.3178 10.7561 36.9726 4.95063 26.9183C-1.08702 16.4747 6.43808 3.37015 18.4695 3.32622Z" fill="black"/><path d="M16.1311 19.8831C16.1311 19.9139 16.1407 19.9441 16.1581 19.9694L17.0586 21.2618C17.0888 21.3056 17.1395 21.3321 17.1948 21.3321L19.9458 21.3339C19.9914 21.3339 20.035 21.3154 20.0659 21.2828L20.5065 20.6563C20.5238 20.6322 20.5065 20.599 20.4757 20.599L16.9513 20.5965C16.9211 20.5965 16.8961 20.5731 16.8961 20.5435L16.898 17H16.133L16.1311 19.8825V19.8831Z" fill="white"/><path d="M31.5336 19.0165L31.5348 17.6495C31.5348 17.623 31.5246 17.5978 31.5053 17.5781L31.0088 17.0975C30.9805 17.0667 30.9452 17.0655 30.9433 17.0655L27.4376 17.063C27.3155 17.063 27.2436 17.132 27.2436 17.2177L27.2404 21.2115C27.2404 21.2966 27.3117 21.3656 27.3521 21.3656L30.8007 21.368C30.8823 21.368 30.9157 21.3588 30.9439 21.3415L31.4867 20.8943C31.5149 20.8752 31.5329 20.845 31.5329 20.8111V19.534H30.8534L31.4828 19.1127C31.5149 19.0911 31.5342 19.0554 31.5342 19.0172M30.7679 20.6294L28.0067 20.6275V19.5316L30.7692 19.5334V20.6294H30.7679ZM30.7679 18.7985L28.0067 18.7966V17.7986L30.7686 17.8005V18.7985H30.7679Z" fill="white"/><path d="M24.8459 17.2558L22.0223 17.254L21.1745 18.1078L21.1719 21.3347H21.9375L21.9388 19.8149L24.9307 19.8167L24.9294 21.3636H25.6925L25.695 18.1103L24.8453 17.2552L24.8459 17.2558ZM24.932 19.0836L23.0417 19.0824C22.9909 19.0824 22.9427 19.1027 22.9087 19.1385L22.5252 19.6313C22.4944 19.6627 22.452 19.6812 22.4083 19.6812H21.9395L21.9407 17.9889L24.9332 17.9908V19.0836H24.932Z" fill="white"/><path d="M11.0293 21.3617H9.6509L7.07782 17.9759H6.06748C6.03151 17.9752 6.00196 17.9457 6.0026 17.9087V17.313C6.0026 17.2766 6.03215 17.2471 6.06812 17.2471L7.43109 17.2483L10.0048 20.6323H11.0299C11.0659 20.6329 11.0954 20.6625 11.0954 20.6994V21.2958C11.0954 21.3321 11.0659 21.3617 11.0299 21.3617" fill="white"/><path d="M11.0973 17.3162V17.9125C11.0973 17.9489 11.0678 17.9784 11.0318 17.9784H10.0067L9.2353 18.99L8.84734 18.9647C8.80238 18.9616 8.77476 19.014 8.80238 19.0504L8.99572 19.3048L7.42849 21.3599H6.06552C6.02955 21.3587 6 21.3291 6 21.2928V20.6964C6 20.6601 6.02955 20.6305 6.06552 20.6305H7.07522L7.86076 19.6005L8.21852 19.6233C8.26349 19.6264 8.29111 19.574 8.26349 19.5377L8.08621 19.3048L9.65408 17.249L11.0318 17.2503C11.0678 17.2503 11.0973 17.2798 11.0973 17.3162Z" fill="white"/><path d="M14.3307 19.6754L12.3742 19.6742L12.9176 18.9398L14.8728 18.9411L14.3307 19.6754Z" fill="white"/></svg>';
  function pinIcon(svg) {
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(38, 50),
      anchor: new google.maps.Point(19, 50),
    };
  }
  var map, infoWindow, geocoder, autocomplete, userMarker;
  var stores = [];
  var userPos = null;
  var activeId = null;
  var selectedPlace = null;
  // xlab     = XDS data from the API   -> X-LAB logo / pin
  // xlabRace = xlab_reseller data      -> X-LAB Race logo / pin
  var $list, $panel, $geo, $search, $msg, $xlab, $xlabRace;
  var tpl = {};
  function esc(s) {
    return $("<div>")
      .text(s == null ? "" : String(s))
      .html();
  }
  // Old script used plain JS truthiness on xlab_reseller; this does the same
  // but treats "false" / "F" / "N" / "0" strings as off.
  function flagOn(v) {
    if (!v) return !1;
    var t = String(v).toLowerCase();
    return !(
      t === "false" ||
      t === "f" ||
      t === "n" ||
      t === "no" ||
      t === "0"
    );
  }
  function getTpl(id) {
    var el = document.getElementById(id);
    return el ? el.innerHTML : "";
  }
  function showMessage(text) {
    if (!text) {
      $msg.attr("hidden", !0).text("");
      return;
    }
    $msg.text(text).removeAttr("hidden");
  }
  function auBounds() {
    return new google.maps.LatLngBounds(
      new google.maps.LatLng(-44.5, 112),
      new google.maps.LatLng(-9.5, 154.5),
    );
  }
  function toRad(n) {
    return (n * Math.PI) / 180;
  }
  function distanceKm(lat1, lng1, lat2, lng2) {
    var dLat = toRad(lat2 - lat1),
      dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    return 12742 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  function normalize(raw, i) {
    var lat = parseFloat(raw.latitude);
    var lng = parseFloat(
      raw.longtitude !== undefined ? raw.longtitude : raw.longitude,
    );
    if (isNaN(lat) || isNaN(lng)) {
      return null;
    }
    return {
      id: i,
      name: raw.storename || "",
      address: raw.full_address || "",
      phone: raw.store_phone || "",
      state: raw.state || "",
      lat: lat,
      lng: lng,
      hours: [
        raw.hours_mon,
        raw.hours_tue,
        raw.hours_wed,
        raw.hours_thu,
        raw.hours_fri,
        raw.hours_sat,
        raw.hours_sun,
      ],
      // Every store the API returns is an XDS store -> now X-LAB
      xlab: !0,
      // Stores flagged xlab_reseller -> now X-LAB Race
      xlabRace: flagOn(raw.xlab_reseller),
      distance: null,
      marker: null,
    };
  }
  function loadStores() {
    $.ajax({ url: API_URL, dataType: "jsonp", timeout: 20000 })
      .done(function (res) {
        var rows = (res && res.stores) || [];
        stores = rows
          .map(normalize)
          .filter(Boolean)
          .filter(function (s) {
            return s.xlab || s.xlabRace;
          });
        stores.forEach(function (s, i) {
          s.id = i;
        });
        createMarkers();
        render(!0);
      })
      .fail(function () {
        $list.html(
          '<p class="fad-empty m-0">Sorry, we couldn\'t load the dealer list. Please try again later.</p>',
        );
      });
  }
  function createMarkers() {
    var iconRace = pinIcon(PIN_XLAB_RACE_SVG);
    var iconXlab = pinIcon(PIN_XLAB_SVG);
    stores.forEach(function (s) {
      s.marker = new google.maps.Marker({
        position: { lat: s.lat, lng: s.lng },
        title: s.name,
        icon: s.xlabRace ? iconRace : iconXlab,
        map: null,
      });
      s.marker.addListener("click", function () {
        selectStore(s, !0);
      });
    });
  }
  function getFiltered() {
    var needXlab = $xlab.is(":checked");
    var needRace = $xlabRace.is(":checked");
    return stores.filter(function (s) {
      if (needXlab && !s.xlab) return !1;
      if (needRace && !s.xlabRace) return !1;
      return !0;
    });
  }
  function buildBlock(s) {
    var h = s.hours.map(function (v) {
      return v || "Closed";
    });
    var days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    function row(i) {
      return '<p class="m-0">' + days[i] + ": " + esc(h[i]) + "</p>";
    }
    var icons = "";
    if (s.xlab) icons += tpl.xlab;
    if (s.xlabRace) icons += tpl.xlabRace;
    var dist =
      s.distance != null
        ? '<span class="store-distance">' +
          s.distance.toFixed(1) +
          " km away</span>"
        : "";
    var dirUrl =
      "https://www.google.com/maps/dir/?api=1&destination=" +
      s.lat +
      "," +
      s.lng;
    return (
      '<div class="store-block' +
      (s.id === activeId ? " is-active" : "") +
      '" data-id="' +
      s.id +
      '" tabindex="0" role="button">' +
      tpl.location +
      '<div class="store-block__inner">' +
      '<div class="store-details"><div class="details-block">' +
      '<p class="m-0 store-name">' +
      esc(s.name) +
      "</p>" +
      '<p class="m-0 store-address">' +
      esc(s.address) +
      (s.phone ? "<br>PH: " + esc(s.phone) : "") +
      dist +
      "</p>" +
      (icons ? '<div class="store-icons">' + icons + "</div>" : "") +
      "</div></div>" +
      '<div class="store-hours">' +
      '<p class="m-0 oh-head">Opening Hours</p>' +
      '<div class="hours-wrapper">' +
      '<div class="hours-block">' +
      row(0) +
      row(1) +
      row(2) +
      row(3) +
      "</div>" +
      '<div class="hours-block">' +
      row(4) +
      row(5) +
      row(6) +
      "</div>" +
      "</div>" +
      "</div>" +
      '<div class="store-directions">' +
      '<a href="' +
      dirUrl +
      '" target="_blank" rel="noopener" class="get-directions-btn">Get Directions ' +
      tpl.arrow +
      "</a>" +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }
  function render(fit) {
    var list = getFiltered();
    if (userPos) {
      list.forEach(function (s) {
        s.distance = distanceKm(userPos.lat, userPos.lng, s.lat, s.lng);
      });
      list.sort(function (a, b) {
        return a.distance - b.distance;
      });
      var near = list.filter(function (s) {
        return s.distance <= RADIUS_KM;
      });
      if (near.length) {
        list = near.slice(0, MAX_RESULTS);
        showMessage("");
      } else {
        list = list.slice(0, MIN_RESULTS);
        if (list.length)
          showMessage(
            "No dealers within " +
              RADIUS_KM +
              " km. Showing the nearest dealers.",
          );
      }
    } else {
      stores.forEach(function (s) {
        s.distance = null;
      });
      list.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
    var visible = {};
    list.forEach(function (s) {
      visible[s.id] = !0;
    });
    stores.forEach(function (s) {
      if (s.marker) s.marker.setMap(visible[s.id] ? map : null);
    });
    $list.empty();
    if (!list.length) {
      $list.html(
        '<p class="fad-empty m-0">No dealers found. Try changing your filters or search.</p>',
      );
    } else {
      $list.html(list.map(buildBlock).join(""));
    }
    $panel.scrollTop(0);
    if (fit) fitMap(list);
  }
  function fitMap(list) {
    if (!userPos) {
      map.fitBounds(auBounds());
      return;
    }
    var bounds = new google.maps.LatLngBounds();
    bounds.extend(userPos);
    list.slice(0, 3).forEach(function (s) {
      bounds.extend({ lat: s.lat, lng: s.lng });
    });
    map.fitBounds(bounds, 60);
    google.maps.event.addListenerOnce(map, "idle", function () {
      if (map.getZoom() > 14) map.setZoom(14);
    });
  }
  function buildInfoContent(s) {
    var days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    var hours = days
      .map(function (d, i) {
        return (
          '<div class="fad-iw__row"><span>' +
          d +
          "</span><span>" +
          esc(s.hours[i] || "Closed") +
          "</span></div>"
        );
      })
      .join("");
    var logos = "";
    if (s.xlab) logos += tpl.xlab;
    if (s.xlabRace) logos += tpl.xlabRace;
    return (
      '<div class="fad-iw">' +
      '<p class="fad-iw__name">' +
      esc(s.name) +
      "</p>" +
      '<p class="fad-iw__address">' +
      esc(s.address) +
      "</p>" +
      (s.phone ? '<p class="fad-iw__phone">PH: ' + esc(s.phone) + "</p>" : "") +
      (logos ? '<div class="fad-iw__logos">' + logos + "</div>" : "") +
      '<p class="fad-iw__head">Opening Hours</p>' +
      '<div class="fad-iw__hours">' +
      hours +
      "</div>" +
      "</div>"
    );
  }
  function selectStore(s, fromMarker) {
    if (!s || !s.marker) {
      return;
    }
    activeId = s.id;
    $list.find(".store-block").removeClass("is-active");
    var $block = $list
      .find('.store-block[data-id="' + s.id + '"]')
      .addClass("is-active");
    map.panTo({ lat: s.lat, lng: s.lng });
    map.setZoom(15);
    infoWindow.setContent(buildInfoContent(s));
    infoWindow.open(map, s.marker);
    if (fromMarker && $block.length) {
      $panel
        .stop()
        .animate(
          { scrollTop: $block.position().top + $panel.scrollTop() - 10 },
          300,
        );
    } else {
      var rect = document.getElementById("map-canvas").getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        $("html, body").animate(
          { scrollTop: $("#map-canvas").offset().top - 20 },
          400,
        );
      }
    }
  }
  function setUserPosition(latLng, label) {
    userPos = { lat: latLng.lat(), lng: latLng.lng() };
    showMessage("");
    if (userMarker) userMarker.setMap(null);
    userMarker = new google.maps.Marker({
      position: userPos,
      map: map,
      title: "Your location",
      zIndex: 999,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: "#4285F4",
        fillOpacity: 1,
        strokeColor: "#fff",
        strokeWeight: 2,
      },
    });
    infoWindow.close();
    activeId = null;
    render(!0);
  }
  function resetSearch() {
    userPos = null;
    selectedPlace = null;
    activeId = null;
    if (userMarker) {
      userMarker.setMap(null);
      userMarker = null;
    }
    if ($search) $search.val("");
    $geo.val("");
    showMessage("");
    infoWindow.close();
    render(!0);
  }
  function useMyLocation() {
    if (!navigator.geolocation) {
      showMessage("Your browser does not support location services.");
      return;
    }
    $geo.val("Locating...");
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        var ll = new google.maps.LatLng(
          pos.coords.latitude,
          pos.coords.longitude,
        );
        $search.val("");
        selectedPlace = null;
        $geo.val("");
        geocoder.geocode({ location: ll }, function (results, status) {
          if (status === "OK" && results[0]) {
            $geo.val(results[0].formatted_address);
          } else {
            $geo.val("Current location");
          }
        });
        setUserPosition(ll, "geolocation");
      },
      function (err) {
        $geo.val("");
        var msgs = {
          1: "Location permission denied. Please allow location access or search by suburb.",
          2: "Your position is unavailable. Please search by suburb instead.",
          3: "Locating timed out. Please try again or search by suburb.",
        };
        showMessage(msgs[err.code] || "Unable to get your location.");
      },
      { enableHighAccuracy: !0, timeout: 10000, maximumAge: 60000 },
    );
  }
  function searchFromText() {
    var text = $.trim($search.val());
    if (!text) {
      if (userPos) resetSearch();
      return;
    }
    if (
      selectedPlace &&
      selectedPlace.geometry &&
      $search.val() === selectedPlace._label
    ) {
      $geo.val("");
      setUserPosition(selectedPlace.geometry.location, "autocomplete");
      return;
    }
    geocoder.geocode(
      { address: text, componentRestrictions: { country: COUNTRY } },
      function (results, status) {
        if (status === "OK" && results[0]) {
          $geo.val("");
          setUserPosition(results[0].geometry.location, "geocode");
        } else {
          showMessage(
            "We couldn't find that location. Please try another suburb or postcode.",
          );
        }
      },
    );
  }
  function initSearchInput() {
    $("#input_location").html(
      '<div class="location-search">' +
        '<input type="text" class="with-ico" id="fad-search" placeholder="Enter a place, city or suburb..." autocomplete="off">' +
        "</div>",
    );
    $search = $("#fad-search");
    if (google.maps.places && google.maps.places.Autocomplete) {
      autocomplete = new google.maps.places.Autocomplete($search[0], {
        componentRestrictions: { country: COUNTRY },
        fields: ["geometry", "formatted_address", "name"],
      });
      autocomplete.addListener("place_changed", function () {
        var place = autocomplete.getPlace();
        if (place && place.geometry) {
          selectedPlace = place;
          place._label = $search.val();
          $geo.val("");
          setUserPosition(place.geometry.location, "place_changed");
        }
      });
    }
    $search.on("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        searchFromText();
      }
    });
    $search.on("input", function () {
      selectedPlace = null;
      if (!$.trim($search.val()) && userPos) resetSearch();
    });
  }
  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    params.delete("xds");
    $xlab.is(":checked") ? params.set("xlab", "true") : params.delete("xlab");
    $xlabRace.is(":checked")
      ? params.set("xlab-race", "true")
      : params.delete("xlab-race");
    var qs = params.toString();
    history.replaceState(
      null,
      "",
      window.location.pathname + (qs ? "?" + qs : ""),
    );
  }
  function init() {
    $list = $("#store-list");
    $panel = $("#panel-v2");
    $geo = $("#getlocation");
    $msg = $("#fad-message");
    $xlab = $("#xlab-checkbox");
    $xlabRace = $("#xlab-race-checkbox");
    tpl.location = getTpl("fad-tpl-location");
    tpl.xlab = getTpl("fad-tpl-xlab");
    tpl.xlabRace = getTpl("fad-tpl-xlab-race");
    tpl.arrow = getTpl("fad-tpl-arrow");
    map = new google.maps.Map(document.getElementById("map-canvas"), {
      center: { lat: -28, lng: 135 },
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });
    map.fitBounds(auBounds());
    infoWindow = new google.maps.InfoWindow();
    geocoder = new google.maps.Geocoder();
    var params = new URLSearchParams(window.location.search);
    if (params.get("xlab") === "true") $xlab.prop("checked", !0);
    if (params.get("xlab-race") === "true") $xlabRace.prop("checked", !0);
    initSearchInput();
    $geo.on("click", useMyLocation);
    $("#enter-location").on("click", searchFromText);
    $('.fad-filter input[type="checkbox"]').on("change", function () {
      syncUrl();
      infoWindow.close();
      activeId = null;
      render(!0);
    });
    $list.on("click", ".store-block", function (e) {
      if ($(e.target).closest(".get-directions-btn").length) return;
      var id = parseInt($(this).attr("data-id"), 10);
      var s = stores[id];
      if (s) selectStore(s, !1);
    });
    $list.on("keydown", ".store-block", function (e) {
      if (
        e.key === "Enter" &&
        !$(e.target).closest(".get-directions-btn").length
      )
        $(this).trigger("click");
    });
    loadStores();
  }
  function boot(tries) {
    if (window.google && google.maps && google.maps.Map) {
      init();
    } else if (tries < 100) {
      setTimeout(function () {
        boot(tries + 1);
      }, 100);
    } else {
      console.error(
        "[FAD] Google Maps failed to load. Check the Maps script tag and API key.",
      );
    }
  }
  $(function () {
    boot(0);
  });
})(jQuery);
